import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.33203 18.333H16.6654",
  stroke: "currentColor",
  "stroke-width": "1.2",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.5721 3.05276L12.19 2.43484C13.2138 1.41104 14.8737 1.41104 15.8975 2.43484C16.9213 3.45865 16.9213 5.11856 15.8975 6.14236L15.2796 6.76028M11.5721 3.05276C11.5721 3.05276 11.6493 4.36584 12.8079 5.52444C13.9665 6.68304 15.2796 6.76028 15.2796 6.76028M11.5721 3.05276L5.89125 8.73359C5.50647 9.11837 5.31409 9.31075 5.14863 9.52288C4.95345 9.77311 4.78612 10.0439 4.64959 10.3303C4.53385 10.5732 4.44782 10.8313 4.27574 11.3475L3.54657 13.535M15.2796 6.76028L9.59877 12.4411C9.21399 12.8259 9.0216 13.0183 8.80947 13.1837C8.55924 13.3789 8.28849 13.5462 8.00202 13.6828C7.75916 13.7985 7.50105 13.8845 6.98482 14.0566L4.79731 14.7858M4.79731 14.7858L4.26259 14.964C4.00855 15.0487 3.72847 14.9826 3.53912 14.7932C3.34977 14.6039 3.28365 14.3238 3.36833 14.0698L3.54657 13.535M4.79731 14.7858L3.54657 13.535",
  stroke: "currentColor",
  "stroke-width": "1.2"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }